import { createContext } from 'react';
import type { Locale } from '../types';
import { DEFAULT_LOCALE } from './defaultLocale';

interface NewTranslationsContextContextType {
  locale: Locale;
}

const NewTranslationsContext = createContext<NewTranslationsContextContextType>({
  locale: DEFAULT_LOCALE,
});

export default NewTranslationsContext;
